import type { FaireProductEntity } from "../../entity_types/product";

export const p_buq7e2u9mp: FaireProductEntity = {
  token: "p_buq7e2u9mp",
  type: "product",
  name: "Anya",
  brandToken: "b_cm6t2hxqzv",
  brandName: "By Orly",
  imageUrl:
    "https://cdn.faire.com/fastly/6cdd92cbe8f8e785469ce55cc6c4f7e003a7503f27f2be7b859dd07357a2acb9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/67af06a663cd7031ec0f26b48984df451301ff575b82e6d09e39f2e1c55f82fd.jpeg",
    "https://cdn.faire.com/fastly/981f3d1a4c692dd2b3a13452a40be785642788ea8ddfd18016376ac118380af5.jpeg",
    "https://cdn.faire.com/fastly/44dff348f34c2b0f1238ecb43b5ccd75275d470ef589de426a1c6c60b30011bd.jpeg",
    "https://cdn.faire.com/fastly/47767d15235fe2dbee50e15734d8d15620abe4b2f95bd3ae752b9570f09bd1cf.jpeg",
    "https://cdn.faire.com/fastly/e9f544984167eb451541f7fe624d00cfddcced19df57862ad0d826ff77545789.jpeg",
  ],
  priceDollars: 75,
  description:
    "A luxurious assembly of neutral beads featuring a bold touch of red. Incorporating a variety of shapes of natural gemstones in a refined color palette, with a striking addition of color.\n\n• Black Onyx, Clear Quartz, Red Jasper, Yellow Opal, Yellow Topaz\n• Gold Filled Clasp\n\n• Please note this is an asymmetric pattern using natural gems and there will be slight variations making each piece one of a kind.",
  tags: [],
  msrpDollars: 150,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:02.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
